import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { isUndefined, noop } from 'lodash';
import React from 'react';

const DropdownContents = React.forwardRef(
  ({
    ariaLabel,
    canScroll,
    children,
    className,
    direction,
    isLoading,
    isNoWrap,
    maxHeight,
    minWidth,
    renderHeader = noop,
    testSection,
    ...props
  }, ref) => {
    const styleProps = {};
    if (!isUndefined(isLoading)) {
      styleProps.position = "relative";
    }
    if (minWidth) {
      styleProps.minWidth = minWidth;
    }
    if (canScroll) {
      styleProps.overflowY = "visible";
      styleProps.maxHeight = "none";
    }
    const wrapperClasses = classNames(
      {
        nowrap: isNoWrap,
        "oui-dropdown": true,
        "oui-dropdown--right": direction === "left",
        "oui-dropdown--up": direction === "up"
      },
      className
    );
    const listClasses = classNames("axiom-dropdown__list", {
      "min-height--100": isLoading
    });
    const wrapperStyles = {};
    if (maxHeight) {
      wrapperStyles.maxHeight = maxHeight;
    }
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: wrapperClasses,
        ref,
        style: wrapperStyles,
        ...props,
        children: [
          renderHeader(),
          /* @__PURE__ */ jsx(
            "ul",
            {
              "aria-label": ariaLabel,
              className: listClasses,
              role: "listbox",
              style: styleProps,
              ...testSection ? { "data-test-section": testSection } : {},
              children
            }
          )
        ]
      }
    );
  }
);
DropdownContents.displayName = "DropdownContents";
DropdownContents.defaultProps = {
  canScroll: false,
  direction: "left",
  isLoading: void 0,
  isNoWrap: false,
  testSection: ""
};

export { DropdownContents, DropdownContents as default };
